// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2TPj7","approved":"Status_approved__3V8X4","rejected":"Status_rejected__3rZCL","expired":"Status_expired__1FbZe","label":"Status_label__1oolq"};